// extracted by mini-css-extract-plugin
export default {"stepperContainer":"DocumentCaptureProgressStepper__stepperContainer-KYZL"};